<template>
  <div class="container">
    <div
      class="recipegrid recipegrid--grid"
      v-if="!this.isSlider || this.$mq.min.md"
    >
      <RecipeItem
        v-for="(recipe, index) in recipes"
        :key="'recipeitem' + index"
        :recipe="recipe"
      />
    </div>

    <div class="recipegrid recipegrid--slider" v-else>
      <swiper :options="swiperOption" ref="mySwiper">
        <swiper-slide
          v-for="(recipe, index) in recipes"
          :key="'recipeitem' + index"
        >
          <RecipeItem :recipe="recipe" />
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>
<script>
import RecipeItem from "@/components/entry/RecipeItem.vue";
export default {
  name: "RecipeGrid",
  components: {
    RecipeItem
  },
  props: {
    recipes: { type: Array },
    slider: { default: false }
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: "auto",
        spaceBetween: 0
      }
    };
  },
  computed: {
    isSlider() {
      return typeof this.slider === "string";
    }
  },
  mounted() {}
};
</script>
<style lang="scss">
.recipegrid {
  margin-bottom: 20px;
  &--grid {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -$gap;
  }
  > .cp-recipe-item {
    width: 100%;
    @include breakpoint(sm-min) {
      width: 50%;
    }
    @include breakpoint(md-min) {
      width: calc(100% / 3);
    }
  }
  .swiper-slide {
    width: 90%;
    @include breakpoint(sm-min) {
      width: 50%;
    }
    .cp-recipe-item,
    .recipe__card {
      width: 100%;
    }
  }
  .swiper-container {
    overflow: visible;
  }
}
</style>
